import { Component } from "../base/Component";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export interface ResizeListener extends EventListener<ResizeEvent> {
}

export class ResizeEvent extends Event<Component> {
    constructor(target: Component, domEvent?: Event | DomEvent) {
        super(target, domEvent);
    }
}
